import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import moment from 'moment';
import { withVenuesApi } from 'cw-styleguide-react';
import i18n from "../../../i18n";
import { STEP_SESSION_VIEW, STEP_SESSION_CREATE, STEP_SESSION_DETAILS, STEP_SESSION_CONTACT, STEP_SESSION_VENUES } from "../../../constants";
import withAssets from "../../../components/hoc/withAssets";
import SessionsCreateStep from "./steps/SessionsCreateStep";
import SessionsDetailsStep from "./steps/SessionsDetailsStep";
import SessionsContactStep from "./steps/SessionsContactStep";
import SessionsVenuesStep from "./steps/SessionsVenuesStep";
import SessionsViewStep from "./steps/SessionsViewStep";

class CoursesSessionsForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: this.props.sessions.length > 0 ? STEP_SESSION_VIEW : STEP_SESSION_CREATE,
      loadedSessionUuid: ''
    };

    this.loadSession = this.loadSession.bind(this);
    this.handleSetStep = this.handleSetStep.bind(this);
    this.handleSaveSession = this.handleSaveSession.bind(this);
    this.handleLoadSession = this.handleLoadSession.bind(this);
    this.handleClearSession = this.handleClearSession.bind(this);
  }

  componentDidMount() {
    if (this.props.errorActiveSessionStep) {
      this.setState({
        step: this.props.errorActiveSessionStep
      });
    }

    if (this.props.errorActiveSessionId) {
      const session = this.props.sessions.find(session => session.id === this.props.errorActiveSessionId);

      if (session) {
        this.loadSession(session);
      }
    }

    // if (this.props.location.hash) {
    //   this.props.handleScrollToElement(this.props.location.hash.substring(1));
    // }
  }

  componentDidUpdate(prevProps) {
    if (this.props.errorActiveSessionStep && this.props.errorActiveSessionStep !== prevProps.errorActiveSessionStep) {
      this.setState({
        step: this.props.errorActiveSessionStep
      });
    }

    if (this.props.errorActiveSessionId && this.props.errorActiveSessionId !== prevProps.errorActiveSessionId) {
      const session = this.props.sessions.find(session => session.id === this.props.errorActiveSessionId);

      if (session) {
        this.loadSession(session);
      }
    }

    // if (this.props.location.hash !== prevProps.location.hash) {
    //   this.props.handleScrollToElement(this.props.location.hash.substring(1));
    // }
  }

  loadSession(session) {
    this.setState({
      loadedSessionUuid: session.uuid
    });

    const startDate = moment(session.startDate, 'YYYY-MM-DDTHH:mm:ss[Z]', true);

    this.props.handleSet({
      sessionId: session.id,
      startDate: startDate.isValid() ? startDate.format('YYYYMMDD') : session.startDate,
      startDetails_en: session.startDetails?.en,
      startDetails_cy: session.startDetails?.cy,
      daysTimes_en: session.daysTimes?.en,
      daysTimes_cy: session.daysTimes?.cy,
      studyMethodType: new Set(session.studyMethodType),
      studyMethodHours: new Set(session.studyMethodHours),
      studyMethodTimes: new Set(session.studyMethodTimes),
      contacts: session.contact ? [session.contact] : [],
      venues: session.venues || []
    });
  }

  handleSetStep(e, step) {
    e.preventDefault();

    this.setState({
      step: step
    });
  }

  handleSaveSession(e) {
    e.preventDefault();

    const startDate = moment(this.props['startDate'], 'YYYYMMDD', true);

    const session = {
      uuid: this.state.loadedSessionUuid || uuidv4(),
      startDate: startDate.isValid() ? startDate.format('YYYY-MM-DDTHH:mm:ss[Z]') : this.props['startDate'],
      startDetails: {
        en: this.props.startDetails_en || '',
        cy: this.props.startDetails_cy || ''
      },
      daysTimes: {
        en: this.props.daysTimes_en || '',
        cy: this.props.daysTimes_cy || ''
      },
      studyMethodType: [...this.props.studyMethodType],
      studyMethodHours: [...this.props.studyMethodHours],
      studyMethodTimes: [...this.props.studyMethodTimes],
      contact: this.props.contacts?.[0],
      venues: this.props.venues
    };

    let sessions = this.props.sessions;

    if (this.state.loadedSessionUuid) {
      const sessionIndex = sessions.findIndex(session => session.uuid === this.state.loadedSessionUuid);
      sessions[sessionIndex] = session;
    }
    else {
      sessions.push(session);
    }

    sessions = sessions.map((session, index) => {
      session.id = index + 1;

      return session;
    });

    this.setState({
      loadedSessionUuid: ''
    });

    this.props.handleSet({
      sessions: sessions,

      // Reset create session fields.
      sessionId: '',
      startDate: '',
      startDetails_en: '',
      startDetails_cy: '',
      daysTimes_en: '',
      daysTimes_cy: '',
      studyMethodType: new Set(),
      studyMethodHours: new Set(),
      studyMethodTimes: new Set(),
      contactId: '',
      contactLabel: '',
      contacts: [],
      venueId: '',
      venueLabel: '',
      venueContactId: '',
      venueContactLabel: '',
      venues: []
    });
  }

  handleClearSession() {
    this.setState({
      loadedSessionUuid: ''
    });

    this.props.handleSet({
      sessionId: '',
      startDate: '',
      startDetails_en: '',
      startDetails_cy: '',
      daysTimes_en: '',
      daysTimes_cy: '',
      studyMethodType: new Set(),
      studyMethodHours: new Set(),
      studyMethodTimes: new Set(),
      contactId: '',
      contactLabel: '',
      contacts: [],
      venueId: '',
      venueLabel: '',
      venueContactId: '',
      venueContactLabel: '',
      venues: []
    });
  }

  handleLoadSession(e, session) {
    e.preventDefault();

    this.loadSession(session);
  }

  render() {
    return (
      <Fragment>
        {this.state.step === STEP_SESSION_CREATE &&
          <SessionsCreateStep
            sessions={this.props.sessions}
            handleSetStep={this.handleSetStep} />
        }
        {this.state.step === STEP_SESSION_DETAILS &&
          <SessionsDetailsStep
            loadedSessionUuid={this.state.loadedSessionUuid}
            sessions={this.props.sessions}
            sessionId={this.props.sessionId}
            startDate={this.props.startDate}
            startDetails_en={this.props.startDetails_en}
            startDetails_cy={this.props.startDetails_cy}
            daysTimes_en={this.props.daysTimes_en}
            daysTimes_cy={this.props.daysTimes_cy}
            studyMethodType={this.props.studyMethodType}
            studyMethodHours={this.props.studyMethodHours}
            studyMethodTimes={this.props.studyMethodTimes}
            step={this.state.step}
            errors={this.props.errors}
            errorActiveField={this.props.errorActiveField}
            inputLanguage={this.props.inputLanguage}
            // location={this.props.location}
            handleSetStep={this.handleSetStep}
            handleChange={this.props.handleChange}
            handleSet={this.props.handleSet}
            handleScrollTop={this.props.handleScrollTop}
            handleClearSession={this.handleClearSession}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
        {this.state.step === STEP_SESSION_CONTACT &&
          <SessionsContactStep
            loadedSessionUuid={this.state.loadedSessionUuid}
            sessions={this.props.sessions}
            sessionId={this.props.sessionId}
            mainProviderId={this.props.mainProviderId}
            contactId={this.props.contactId}
            contactLabel={this.props.contactLabel}
            contacts={this.props.contacts}
            step={this.state.step}
            errors={this.props.errors}
            errorActiveField={this.props.errorActiveField}
            inputLanguage={this.props.inputLanguage}
            handleSetStep={this.handleSetStep}
            handleChange={this.props.handleChange}
            handleSet={this.props.handleSet}
            handleClearSession={this.handleClearSession}
            handleScrollTop={this.props.handleScrollTop}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
        {this.state.step === STEP_SESSION_VENUES &&
          <SessionsVenuesStep
            loadedSessionUuid={this.state.loadedSessionUuid}
            sessions={this.props.sessions}
            sessionId={this.props.sessionId}
            venueId={this.props.venueId}
            venueLabel={this.props.venueLabel}
            mainProviderId={this.props.mainProviderId}
            venueContactId={this.props.venueContactId}
            venueContactLabel={this.props.venueContactLabel}
            venues={this.props.venues}
            step={this.state.step}
            errors={this.props.errors}
            errorActiveField={this.props.errorActiveField}
            inputLanguage={this.props.inputLanguage}
            handleSetStep={this.handleSetStep}
            handleChange={this.props.handleChange}
            handleSet={this.props.handleSet}
            handleSaveSession={this.handleSaveSession}
            handleClearSession={this.handleClearSession}
            handleScrollTop={this.props.handleScrollTop}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
        {this.state.step === STEP_SESSION_VIEW &&
          <SessionsViewStep
            sessions={this.props.sessions}
            sessionId={this.props.sessionId}
            errorActiveField={this.props.errorActiveField}
            handleSetStep={this.handleSetStep}
            handleSet={this.props.handleSet}
            handleLoadSession={this.handleLoadSession}
            handleClearActiveErrors={this.props.handleClearActiveErrors} />
        }
      </Fragment>
    );
  }

}

export default withVenuesApi(process.env)(withAssets(withTranslation('local')(CoursesSessionsForm)));
